import { ReactElement, useEffect } from 'react';
import { Outlet } from 'react-router';

// Store.
import { resetActivitySearch } from 'store/activity/actions';
import { useAppDispatch } from 'core';

export const ActivityPage = (): ReactElement => {
  const dispatch = useAppDispatch();

  // Reset activity search on unmount.
  useEffect((): VoidFunction => {
    return () => {
      dispatch(resetActivitySearch());
    };
  }, [dispatch]);

  return <Outlet />;
};
